import { defineModule } from "../define.ts";

/**
 * Messages (PMU-233): a conversation about each child between their parents and the school (the
 * child's teachers and the office), and conversations between the staff of one organisation: a
 * school's, or a bus company's crews and dispatchers. Live in the apps, with a push when the app is
 * not open. On for every organisation; switched off per organisation like any module.
 */
export const messages = defineModule({
  id: "messages",
  name: "Messages",
  version: "0.1.0",
  description: "Parents and teachers talk about a child; staff of one organisation talk to each other.",
  core: true,
  grants: {
    // Talking with parents: the child's teachers, and the office (site and organisation admins).
    "messages:families": ["org_admin", "site_admin", "teacher"],
    // Staff conversations within the organisation. Bus crews and dispatchers get it with their roles (transport manifest).
    "messages:staff": ["org_admin", "site_admin", "door_staff", "teacher"],
  },
});
